import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {hideApiError} from '/redux/action/apiError.action';
import {
  getFailedToProcessRequestErrorState,
  getServerIsDownErrorState,
} from '/redux/selector/apiError.selector';
import {
  currentScreen,
  currentScreenParams,
} from '/redux/selector/navigation.selector';

import {ApiErrorProvider} from './ApiErrorProvider';

const mapDispatchToProps = {
  hideApiError: ({errorCode}: any) => hideApiError({errorCode}),
};

const ApiErrorProviderConnected = connect(
  createStructuredSelector({
    currentScreen: currentScreen,
    currentScreenParams,
    isShowingServerIsDown: getServerIsDownErrorState,
    isShowingFailedToProcessRequest: getFailedToProcessRequestErrorState,
  }),
  mapDispatchToProps,
)(ApiErrorProvider);

export {ApiErrorProviderConnected as ApiErrorProvider};
